/* eslint-disable max-len */

import { AvatarCustom } from "../../../components";
import React from "react";
import SocAddIcon from "../../../components/Icons/SocAddIcon";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { useSearchParams } from "react-router-dom";
import { useUserStore } from "../../../hooks/redux-hooks/user-store/user.store";

const WellnessPlanPetDetailsCard = () => {
  const [searchParams] = useSearchParams();
  const { petList } = usePetStore();
  const { user } = useUserStore();
  const petId = searchParams.get("id");
  const currentPet = petList?.filter((pet) => pet.id == petId);

  return (
    <div className="rounded-xl p-4 w-full">
      <div className="w-full flex gap-3 ">
        <div className="relative">
          <AvatarCustom
            image={currentPet && currentPet[0]?.image}
            width={80}
            height={80}
            name={currentPet && currentPet[0]?.name}
          />
          <div className="absolute top-14 right-0">
            <SocAddIcon height={25} width={25} />
          </div>
        </div>
        <div className="flex flex-col mt-2">
          <div className="text-xl font-semibold capitalize gap-2">
            {currentPet ? currentPet[0]?.name : ""}
          </div>
          <div>
            <div className="text-base">
              {currentPet ? currentPet[0]?.name : ""}&apos;s Plan will be
                  applied to your home hospital:
            </div>
            <div className="text-base font-semibold capitalize">
                  GoodVets {user?.location?.locationName}
            </div>
          </div>
        </div>
      </div>
      <div />
    </div>
  );
};

export default WellnessPlanPetDetailsCard;
